var $ = require("jquery");
// Set Lang for ES
function setLanguage(){
  window.visaton_language=$('html').attr('lang');//declaring global variable by window object
}

$(function() {
  require("./_components/product_search.js");
  require("headjs/dist/1.0.0/head.js");
  require("object-fit-images")();
  require("object-fit-videos")();
  // require('inline-video/inline-video.js');
  // require('slick-autopause/slick-autopause.js');
  require("./_components/slider.js");
  require("./_components/header.js");
  require("./_components/toggle.js");
  require("./_components/reference.js");
  require("./_components/quicklinks.js");
  require("./_components/hero.js");
  require("./_components/360.js");
  require("./_components/product.js");
  require("./_components/icon-tabs.js");
  require("./_components/cookie-banner.js");
  require("./_components/facts.js");
  require("./_components/graphic.js");
  require("./_components/filter.js");
  require("./_components/map.js");
  require("lightbox2");
  require("fastclick")(document.body);
});

$(window).on("load", function() {

  setLanguage()

  var $wrapper = $('.contact_form_unternehmen');
  var $company = $('#edit-company-0');
  var $private = $('#edit-company-1');
  var $selected = $('input[name="company"]:checked', '#edit-company');

  $company.click(function(){
    $wrapper.show();
    $('#edit-unternehmen').prop('required',true);
    $('#edit-telefon').prop('required',true);
    $('#edit-adresse').prop('required',true);
    $('#edit-plz').prop('required',true);
    $('#edit-stadt').prop('required',true);
    $('#edit-land').prop('required',true);
  });

  $private.click(function(){
    $wrapper.hide();
    $('#edit-unternehmen').prop('required',false);
    $('#edit-telefon').prop('required',false);
    $('#edit-adresse').prop('required',false);
    $('#edit-plz').prop('required',false);
    $('#edit-stadt').prop('required',false);
    $('#edit-land').prop('required',false);
  });


  // FIXME
  var reviewCheck = $('.dd-review--overview').length;
  var language = $('html').attr('lang');

  if (language == "en") {
    if (reviewCheck == 1) {
      var reviewItems = $('.views-field-field-dd-product-reviews a')
      reviewItems.each(function(e) {
        var reviewItem = $(this).text();
        var newText = reviewItem.replace('Auszug aus', 'Extract from');
        console.log(newText);
        $(this).text(newText);


      })

    }
  }

});
